/*import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
*/

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import Layout from './components/Layout';
import Home from './pages/Home';
import Home2 from './pages/Home2';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/home" element={<Layout><Home /></Layout>} />
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/home2" element={<Layout><Home2 /></Layout>} />
      </Routes>
    </Router>
  );
}

export default App;